module.exports = __webpack_public_path__ + "static/media/shouce1.628e2333.jpg";